import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

export const tenantGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const tenant = localStorage.getItem('tenant.uuid');

  if (!tenant) {
    const redirect = encodeURIComponent(state.url);
    router.navigate(['/maintenance'], { queryParams: { redirect } });
    return false;
  }
  return true;
};
